import "./GlowingButton.css";
export function GlowingButton(props: any) {
    return (<button onClick={props.onClick} className='glowing-btn' style={{
        "--glow-color": props.color ?? "hsl(186, 100%, 50%)"
    } as any}>
        <span className='glowing-txt'>{props.text}</span></button>);
}